import { render } from "./StoreTransfers.vue?vue&type=template&id=96ed68d2&scoped=true"
import script from "./StoreTransfers.vue?vue&type=script&lang=js"
export * from "./StoreTransfers.vue?vue&type=script&lang=js"

import "./StoreTransfers.vue?vue&type=style&index=0&id=96ed68d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ed68d2"]])

export default __exports__